import { fetchAtom } from "data/api/useFetch"
import { useAtomValue } from "jotai"

export const chartsAtom = fetchAtom("/v3/internal/organization/charts")

export function useOrganizationCharts() {
  const { ok } = useAtomValue(chartsAtom)

  return ok ? ok.data : []
}
